<template>
    <div class="search-people">
        <search-by-criteria 
            @recieve-data="handleRecieveData" 
            @reset-data="handleReset" 
            :skip="skip" 
            :limit="limit" 
            :multiblock="false"
            ref="searchByCriteria" />

        <user-preview-list
            :users="userArray"
            :total="total"
        />

        <el-pagination
        v-if="userArray && userArray.length > 0"
        layout="prev, pager, next"
        :total="total"
        hide-on-single-page
        :page-size="limit"
        :current-page="currentPage"
        @current-change="onNavigate"
        />
    </div>
</template>

<script>

import SearchByCriteria from '../searchEventParticipants/SearchByCriteria.vue';
import UserPreviewList from './UserPreviewList.vue';

export default {
    components: {
        SearchByCriteria,
        UserPreviewList,
    },
    computed: {
        skip() {
            const { currentPage, limit } = this;
            return (currentPage - 1) * limit;
        },
    },

    data() {
        return {
            limit: 30,
            currentPage: 1,
            total: null,
            userArray: [],
        };
    },
    methods: {
        handleRecieveData(data) {
            this.userArray = data.items.map(item => item.userContactInfo);
            this.total = data.totalCount;
        },
        onNavigate(nextPage) {
            this.currentPage = nextPage;
        },
        handleReset() {
            this.userArray = [];
            this.total = null;
        },
    },
}
</script>

<style lang="scss">
.search-people {
    &__heading {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
    }

    &__title {
        margin: 0;
        margin-bottom: var(--global-dimension-size-250);
        font-weight: 500;
        font-size: var(--font-size-800);
    }

    &__list {}

    &__item {}

    &__empty-text {}
}
</style>
